import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  mode: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link']),
  size: PropTypes.oneOf(['', 'small', 'large']),
  className: PropTypes.string,
  children: PropTypes.node
};

const defaultProps = {
  type: 'button', // HTML Type; just using props to default to button if it is not provided.
  mode: 'primary',
  size: ''
};

export default class Button extends Component {
  render() {
    const { mode, size, className, children, ...rest } = this.props;
    const classes = ['rec-button', // Base button class
      ['rec-button', mode, size] // Button styling class
        .filter((v) => v !== '')
        .join('-'),
      className //
    ]
      .filter((v) => !!v)
      .join(' ');

    return (
      <button className={classes} {...rest}>
        {children}
      </button>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
